import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { getOwnedSkills } from '../content/skills/skills';
import type { PlayerState } from '../domain/game/types';
import { createCombatActions } from './actions/combatActions';
import { createExplorationActions } from './actions/explorationActions';
import { createMetaActions } from './actions/metaActions';
import { createInitialData } from './helpers';
import type { GameStore } from './types';

export type { GameStore } from './types';

export const gameStore = createStore<GameStore>()((set, get) => ({
  ...createInitialData(),
  ...createExplorationActions(set, get),
  ...createCombatActions(set, get),
  ...createMetaActions(set, get),
}));

export function useGameStore<T>(selector: (state: GameStore) => T): T {
  return useStore(gameStore, selector);
}

export function selectOwnedSkillsFromPlayer(player: PlayerState) {
  return getOwnedSkills(player.skillIds);
}
